import React, { useRef, useState } from 'react';
import { ReactComponent as InfoIcon } from '../../icons/icon_info_markets.svg';
import { getLabel } from '../../data/labels';
import { vibrate } from '../../utils';
import Loader from '../Loader';
import QuaggaScanner from './QuaggaScanner';
import { useCheckTicket } from './CheckTicketContext';

export default function BarcodeScanner() {
    const checkTicket = useCheckTicket();
    const results = useRef([]);
    const scannerRef = useRef(null);
    const [showLoader, setShowLoader] = useState(true);

    function setTicketId(ticketId) {
        vibrate();
        checkTicket.setTicketId(ticketId);
    }
    
    const [isError, setIsError] = useState(false);
    function onError() {
        setIsError(true);
    }

    if (isError) {
        return (
            <div className="h-10 m-2 grid grid-cols-12 flex items-center bg-cs7 text-sx text-cs6 rounded">
                <InfoIcon className="col-start-1 col-end-3 h-12 w-12" />
                <span className="col-start-3 col-end-13 text-sm font-bold">{getLabel('check_ticket.not_supported')}</span>
            </div>
        );
    }

    function addResult(result) {
        results.current = results.current && [...results.current, result];
        handleResults();
    }

    //If found at least two equals scan results
    function handleResults() {
        results.current?.forEach((r,i) => {
            results.current.forEach((r2, i2) => {
                if (i !== i2) {
                    if (r === r2) {
                        setTicketId(r);
                    }
                }
            });
        });
    }

    return (
        <div id="scannerPopupContainer">
            <div id="scannerContainer" ref={scannerRef} style={{position: 'relative', display: `${showLoader ? 'none' : ''}`}}>
                <canvas className="drawingBuffer" style={{position: 'absolute', top: '0px'}} />
                {checkTicket.scannerStarted &&
                    <QuaggaScanner scannerRef={scannerRef} onDetected={(result) => addResult(result)} onScannerReady={() => setShowLoader(false)} onInitError={onError} />
                }
            </div>
            {showLoader &&
                <Loader />
            }
        </div>
    );
}
